export const todoList = state => state.todoList
